import * as React from 'react';
export const LineComponent = (props) => {
    const classString = props.value.style === 'thick' ? 'thick-style' : 'thin-style';
    return (React.createElement("div", { className: 'component line-component', "data-component-type": 'line' },
        React.createElement("hr", { className: `${classString}` })));
};
